import * as React from "react";
import { Nav, Accessibility } from "../../../personal-studio-components/frame";
import * as cls from "./NavbarLogin.module.scss";
import MiniModalNotifications from "../../../personal-studio-components/component/MiniModalNotifications";
export { LoginNavbar };
/**
 * Загружает и отображает панель навигации.
 * @param {Object} props - Атрибуты элемента.
 * @param {Action[]} [props.menu] - Дополнительные пункты меню.
 * @returns {JSX.Element} Элемент JSX.
 * @see {@link StudioFrame.jsx}, {@link ../frame/Action.jsx}
 * @author Айдарбек Артур уулу <kulubaev97@gmail.com>
 * @author Алексей Васьковский <avaskovskiy@umney.ru>
 * @author Екатерина Макеева <emakeeva@umney.ru>
 */
function LoginNavbar({ menu = [], handleSignOut }) {
  const [open, setOpen] = React.useState(false);

  const frameNav = [...menu, Accessibility.OPEN];
  return (
    <div className={cls.studio_navbar_container}>
      <nav className={cls.studio_navbar}>
        <Nav menu={frameNav} />
        {open && (
          <MiniModalNotifications
            openMiniModal={open}
            setOpenMiniModal={setOpen}
          />
        )}
      </nav>
      <Accessibility />
    </div>
  );
}